module.exports = __webpack_public_path__ + "static/media/bolso (40).c3f921c9.jpg";